import { UserProvider } from '@auth0/nextjs-auth0/client';
import type { PropsWithChildren } from 'react';

import AnalyticsProvider from '@/components/app/layout/AnalyticsContextProvider';
import OfferBannerProvider from '@/components/app/layout/OfferBannerProvider';
import PrivacyProvider from '@/components/app/layout/PrivacyProvider';
import IntlProvider from '@/components/layout/IntlProvider';
import AuthProvider from '@/context/auth/AuthContextProvider';
import useIsCalmSleepApp from '@/hooks/useIsCalmSleepApp';

const ClientProviders = ({
	hideAcceptCookiesModal,
	analyticsPageName,
	locale = 'en',
	messages,
	children,
}: PropsWithChildren<{
	hideAcceptCookiesModal?: boolean;
	analyticsPageName?: string;
	locale?: string;
	messages?: Record<string, string>;
}>) => {
	const isCalmSleepApp = useIsCalmSleepApp();

	return (
		<IntlProvider locale={locale} messages={messages ?? {}}>
			<AnalyticsProvider analyticsPageName={analyticsPageName}>
				<UserProvider
					loginUrl={isCalmSleepApp ? '/calm-sleep-app/webapi/auth/login' : '/webapi/auth/login'}
					profileUrl={isCalmSleepApp ? '/calm-sleep-app/webapi/auth/me' : '/webapi/auth/me'}
				>
					<AuthProvider>
						<PrivacyProvider hideAcceptCookiesModal={hideAcceptCookiesModal}>
							<OfferBannerProvider>{children}</OfferBannerProvider>
						</PrivacyProvider>
					</AuthProvider>
				</UserProvider>
			</AnalyticsProvider>
		</IntlProvider>
	);
};

export default ClientProviders;
